// Stubs globais para compatibilidade com código legacy do Adianti
// Evita ReferenceError para BuilderTemplate e __adianti_load_page

declare global {
  interface Window {
    BuilderTemplate?: { loadPage: (...args: unknown[]) => void; load_page: (...args: unknown[]) => void };
    __adianti_load_page?: (...args: unknown[]) => void;
  }
}

(function initLegacyStubs() {
  if (typeof window === 'undefined') return;

  const noop = (...args: unknown[]) => {
    // Log não intrusivo para rastrear chamadas inesperadas
    console.warn('[LegacyStub] chamada de função legacy', args);
  };

  // Stub do objeto BuilderTemplate (usado pelo template do Adianti)
  if (typeof window.BuilderTemplate === 'undefined') {
    window.BuilderTemplate = {
      loadPage: noop,
      load_page: noop,
    };
  }

  // Stub da função global __adianti_load_page
  if (typeof window.__adianti_load_page === 'undefined') {
    window.__adianti_load_page = noop;
  }
})();

export {};
